export default [
  {
    header: ' Ajans Bulut Qr',
  },
  {
    title: 'Güncel Durum',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Müşteri Kartları',
    route: null,
    icon: 'UsersIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'CustomerAdd',
        resource: 'CUSTOMERS_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Customers',
        resource: 'CUSTOMERS_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürün Yönetimi',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Listele',
        route: 'Products',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Paketler',
        route: 'ProjectPackages',
        resource: 'ADMIN_PROJECT_PACKAGES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Lisans Yönetimi',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'LicencesAdd',
        resource: 'ADMIN_LICENCES_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Licences',
        resource: 'ADMIN_LICENCES',
        action: 'read',
      },
    ],
  },
  {
    header: 'Yönetim',
  },
  {
    title: 'Parametreler',
    route: null,
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Listele',
        route: 'Params',
        resource: 'PARAMS_LIST',
        action: 'read',
      },
      {
        title: 'Görsel Galerisi',
        route: 'ZennoStocks',
        resource: 'ADMIN_ZENNO_STOCKS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Günlük Kayıtları',
    route: null,
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Sys Aktiviteleri',
        route: 'EventLogs',
        resource: 'ADMIN_EVENT_LOGS',
        action: 'read',
      },
      {
        title: 'Proje Aktiviteleri',
        route: 'ProjectsEventLogs',
        resource: 'ADMN_PROJECTS_EVENT_LOGS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Sistem Yöneticileri',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Yöneticiler',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Yönetici Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      // {
      //   title: 'Genel Yapılandırma',
      //   route: 'Configs',
      //   resource: 'ADMIN_CONFIG',
      //   action: 'read',
      // },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
